import { en, type Dictionary } from "@/src/i18n/en";

/**
 * Hebrew translations.
 *
 * Deliberately EMPTY at the end of the i18n-infrastructure phase. Translation is
 * a separate, human task — nothing here is machine-translated, because a wrong
 * Hebrew string is worse than an obviously-English one, and this tool is built
 * for Hebrew-speaking DMs who would have to live with the result.
 *
 * Add real Hebrew one key at a time:
 *
 *   const translated: Partial<Dictionary> = {
 *     "tool.select": "בחירה",
 *   };
 *
 * Any key not listed here falls back to English automatically (see translate()
 * in ./index.ts), so a half-finished translation still renders a complete UI.
 */
const translated: Partial<Dictionary> = {
  // Language names are the exception: each is written in its own language, so
  // these are correct as-is regardless of which UI language is active.
  "settings.languageHebrew": "עברית",
};

/**
 * Starts as a copy of English, per the Phase 3 scope. Switching to Hebrew today
 * therefore exercises the RTL layout with readable English text — which is the
 * point: it lets the direction work be verified before any translation lands.
 */
export const he: Partial<Dictionary> = { ...en, ...translated };
